import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import t from 'shared/utils/translation';
import { colors } from '@grnhse/seedling/lib/azalea/constants';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/card_table'. 'node_modules/@grnhse/seedling/lib/azalea/components/card_table.js' implicitly has an 'any' type.
import { Row } from '@grnhse/seedling/lib/azalea/components/card_table';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/modals/use_modal'. 'node_modules/@grnhse/seedling/lib/azalea/components/modals/use_modal.js' implicitly has an 'any' type.
import useModal from '@grnhse/seedling/lib/azalea/components/modals/use_modal';
import Toggle from '@grnhse/seedling/lib/azalea/components/toggle';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '../shared/table_cell'. 'app/webpack/javascripts/gdpr/components/shared/table_cell.js' implicitly has an 'any' type.
import TableCell from '../shared/table_cell';
import EditButton from '../shared/edit_button';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '../shared/offices_field'. 'app/webpack/javascripts/gdpr/components/shared/offices_field.js' implicitly has an 'any' type.
import OfficesField from '../shared/offices_field';
import ToggleWarningModal from '../shared/toggle_warning_modal';
import { MultipleRulesContext } from '../multiple_rules/context';
import { DataRetentionRulesContext } from './context';
import type { DataRetentionRuleInterface } from './data_retention_rule';

type Props = {
  rule: DataRetentionRuleInterface;
};

export default function Rule(props: Props) {
  const { offices } = useContext(MultipleRulesContext);
  const { onEdit, onSave } = useContext(DataRetentionRulesContext);
  const [rule, setRule] = useState(props.rule);
  const [isModalOpen, openModal, closeModal] = useModal(false);
  const [closingModalWithEdit, setClosingModalWithEdit] = useState(false);

  // This callback is required to close the modal before switching to the Edit component
  useEffect(() => {
    if (closingModalWithEdit) {
      // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
      onEdit(rule, false);
    }
  }, [closingModalWithEdit, onEdit, rule]);

  // @ts-expect-error - TS7006 - Parameter 'updatedRule' implicitly has an 'any' type.
  const onToggle = async (updatedRule) => {
    const originalRule = rule;
    setRule(updatedRule);
    // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
    const saveSuccessful = await onSave(updatedRule, true);
    // @ts-expect-error - TS1345 - An expression of type 'void' cannot be tested for truthiness.
    if (!saveSuccessful) {
      setRule(originalRule);
      openModal();
    }
  };

  return (
    <StyledRow
      enabled={rule.enabled}
      data-provides={`retention_rule_${rule.id}`}
    >
      <TableCell data-provides="toggle">
        <ToggleWarningModal
          isOpen={isModalOpen}
          onCancel={() => {
            closeModal();
          }}
          onConfirm={() => {
            closeModal();
            setClosingModalWithEdit(true);
          }}
          buttonText={t(
            'gdpr.data_retention_rules.view.invalid_modal.button_text'
          )}
          text={t('gdpr.data_retention_rules.view.invalid_modal.text')}
          title={t('gdpr.data_retention_rules.view.invalid_modal.title')}
        />
        <Toggle
          enabled={rule.enabled}
          id={`${rule.id}`}
          onClick={() => {
            const updatedRule = { ...rule, enabled: !rule.enabled } as const;
            onToggle(updatedRule).then();
          }}
        />
      </TableCell>
      <TableCell data-provides="offices">
        <OfficesField rule={rule} offices={offices} />
      </TableCell>
      <TableCell data-provides="retention_period">
        {rule.data_retention_days}
      </TableCell>
      <TableCell data-provides="actions">
        <EditButton hideBg onClick={() => onEdit(rule)} data-provides="edit">
          {t('gdpr.data_retention_rules.view.table.rule.edit')}
        </EditButton>
      </TableCell>
    </StyledRow>
  );
}

const StyledRow = styled(Row)`
  color: ${(props) => (props.enabled ? 'initial' : colors.mediumGrey)};
`;
